<template>
  <b-modal
    ref="bModal"
    size="md"
    :title="$t('diagnosis.notificationsModal.templatesList')"
    centered
    modal-class="notification-templates-list"
    qa="notification-templates-list-modal"
  >
    <b-row class="py-3 px-4">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <vt-grid
          qa="notification-templates-list-modal-elements-div"
          pagination
          class="templates-grid"
          :grid-options="gridOptions"
          :row-data="templatesList"
          :column-defs="columnDefs"
        />
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            qa="notification-templates-list-modal-cancel-button"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <b-button
            v-if="selectedRows.length === 1"
            qa="notification-templates-list-modal-delete-button"
            size="sm"
            class="btn__outline mr-2"
            @click="deleteTemplates([gridApi.getSelectedRows()])"
          >
            <i
              class="fal fa-trash-alt mr-2"
              aria-hidden="true"
            />
            {{ $t('global.delete') }}
          </b-button>
          <b-button
            v-if="selectedRows.length === 1"
            qa="notification-templates-list-modal-apply-button"
            size="sm"
            class="btn--primary"
            @click="selectTemplate"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import i18n from '@/lang/i18n'
import { AgGridColumnType, AgGridRowModelType } from '@/shared/models/ag-grid.model'
import CellGridRichText from '@/components/common/CellGridRichText'

export default {
    name: 'NotificationTemplatesList',
    components: {
        VtGrid
    },
    props: {
        templatesList: Array
    },
    data() {
        return {
            selectedRows: [],
            columnDefs: [
                { type: 'customCheckbox' },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc('diagnosis.notificationsModal.templateName'),
                    field: 'title',
                    flex: 1,
                    width: 150,
                    minWidth: 140
                },
                {
                    type: AgGridColumnType.TEXT,
                    headerName: i18n.tc('global.description.modal.description'),
                    cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
                    cellRendererFramework: CellGridRichText,
                    field: 'text',
                    flex: 1,
                    width: 150,
                    minWidth: 280
                }
            ]
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        },
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged,
                getRowHeight: ({ data }) => {
                    // assuming 45 characters per line, with 18 lines
                    const maxLength = Math.max(data.text ? data.text.length : 0)
                    if (maxLength) {
                        let calc = 45 * (Math.floor(maxLength / 25) + 2)
                        if (calc > 200) calc = 220
                        return calc
                    } else {
                        return 30
                    }
                }
            }
        }
    },
    methods: {
        selectTemplate() {
            this.$emit('selectTemplate', this.gridApi.getSelectedRows()[0])
            this.hide()
        },
        deleteTemplates(templates) {
            const templateIds = this.selectedRows.length ? this.selectedRows.map(row => row.id) : templates.map(template => template.id)
            this.$emit('deleteTemplates', templateIds)
            this.hide()
        },
        show() {
            this.$refs.bModal.show()
        },
        hide() {
            this.$_cleanComponentData()
            this.$refs.bModal.hide()
        },
        getContextMenuItems(params) {
            return [
                {
                    name: this.$tc('component.printLabelsModal.deleteTemplate', !this.gridApi.getSelectedRows().length || this.gridApi.getSelectedRows().length === 1 ? 1 : 2),
                    action: () => {
                        if (this.gridApi.getSelectedRows().length) {
                            const templateIds = this.selectedRows.map((template) => template.id)
                            this.deleteTemplates(templateIds)
                        } else {
                            this.deleteTemplates([params?.node.data.id])
                        }
                    }
                },
                {
                    name: this.$t('diagnosis.notificationsModal.applyTemplate'),
                    action: () => {
                        this.$emit('selectTemplate', params?.node.data)
                        this.hide()
                    }
                }
            ]
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onGridReady({ api }) {
            this.gridApi = api
        }
    }
}

</script>

<style lang="scss">
    .notification-templates-list .modal-body {
        padding: 10px;
    }

    .notification-templates-list .templates-grid {
        height: calc(50vh - 170px);
    }
</style>

<style lang="scss" scoped>
    .notification-templates-list span {
        font-size: font-size(very-normal);
    }
</style>
